import Input from "../../../../core/Input/Input";
import React from "react";
import {useTranslation} from "react-i18next";

function CreateRoomInput(props) {
    const {
        name,
        placeholder,
        label,
        handleConventionsChange,
        value,
        minBet,
        maxBet,
        currency,
        createDisabled
    } = props;
    const {t} = useTranslation();

    const onInputChange = (value = '') => {
        if (value === '') {
            handleConventionsChange({ [name]: '' });
            return;
        }

        const validInputRegex = /^(\d+)?(\.)?(\d{0,3})?$/;

        if (!validInputRegex.test(value)) return;

        if (value.endsWith('.') || /\.\d{0,2}0?$/.test(value)) {
            handleConventionsChange({ [name]: value });
            return;
        }

        const numericValue = parseFloat(value);

        if (!isNaN(numericValue)) {
            handleConventionsChange({ [name]: numericValue });
        }
    };

    return (
        <div className="create-room--input">
            <Input
                type="createRoom"
                name={name}
                label={label}
                placeholder={placeholder}
                handleChange={onInputChange}
                value={value}
            />
            {createDisabled && <span
                className="create-room--input__msg">{`${t("form.min")} ${minBet} ${currency} / ${t("form.max")} ${maxBet} ${currency}`}</span>}
        </div>
    )
}

export default CreateRoomInput;